import React from "react";
import Container from 'react-bootstrap/Container';
import { Footer } from './headerFooter';
import "./custom.scss";

const PrivacyPolicy = () => {
  return (
    <div id="root">
        <main className='main-container'>
            <Container className='custom-container pt-3'>
                <h2>Πολιτική Απορρήτου & Προστασία Προσωπικών Δεδομένων (GDPR)</h2>
                <p className="last-updated">Τελευταία ενημέρωση: 5 Ιουνίου 2025</p>

                <h3>1. Συλλογή Δεδομένων</h3>
                <p>
                    Στην εφαρμογή <strong>teachers-app.com</strong>, συλλέγουμε μόνο τα απολύτως απαραίτητα προσωπικά δεδομένα για τη λειτουργία της υπηρεσίας μας. Συγκεκριμένα:
                </p>
                <ul>
                    <li>Ονοματεπώνυμο</li>
                    <li>Email</li>
                    <li>Εκπαιδευτικός κλάδος (π.χ. ΠΕ60, ΠΕ02)</li>
                </ul>
                <p>
                    Τα δεδομένα αυτά παρέχονται κατά την εγγραφή και χρησιμοποιούνται αποκλειστικά για στατιστικούς σκοπούς και για τη βελτίωση της εφαρμογής.
                </p>

                <h3>2. Εγγραφή, Σύνδεση και Φόρμα Επικοινωνίας</h3>
                <p>
                    Η εφαρμογή απαιτεί εγγραφή και σύνδεση των χρηστών. Επίσης, παρέχεται δυνατότητα επικοινωνίας μέσω σχετικής φόρμας, μέσω της οποίας μπορεί να υποβληθούν ερωτήσεις ή αιτήματα υποστήριξης.
                </p>

                <h3>3. Cookies και Analytics</h3>
                <p>
                    Η εφαρμογή <strong>δεν χρησιμοποιεί cookies ή υπηρεσίες analytics τρίτων</strong> (όπως Google Analytics) τη δεδομένη χρονική στιγμή.
                </p>

                <h3>4. Φιλοξενία & Τρίτοι Πάροχοι</h3>
                <p>
                    Η εφαρμογή φιλοξενείται σε <strong>shared server της εταιρείας namecheap.com</strong>. Δεν κοινοποιούμε τα προσωπικά δεδομένα σε τρίτους, εκτός αν απαιτείται νομικά.
                </p>

                <h3>5. Διάρκεια Τήρησης Δεδομένων</h3>
                <p>
                    Τα προσωπικά δεδομένα διατηρούνται όσο ο λογαριασμός του χρήστη παραμένει ενεργός. Ο χρήστης μπορεί οποιαδήποτε στιγμή να αιτηθεί διαγραφή του λογαριασμού του, αποστέλλοντας σχετικό αίτημα στο email: <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
                </p>

                <h3>6. Μέτρα Ασφαλείας</h3>
                <p>
                    Η προστασία των δεδομένων σας είναι προτεραιότητά μας. Η εφαρμογή χρησιμοποιεί <strong>SSL κρυπτογράφηση</strong> και <strong>firewalls</strong> για την αποτροπή μη εξουσιοδοτημένης πρόσβασης.
                </p>

                <h3>7. Δικαιώματα Χρηστών (βάσει GDPR)</h3>
                <p>Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (Κανονισμός ΕΕ 2016/679), έχετε τα εξής δικαιώματα:</p>
                <ul>
                    <li>Δικαίωμα πρόσβασης στα δεδομένα σας</li>
                    <li>Δικαίωμα διόρθωσης ανακριβειών</li>
                    <li>Δικαίωμα διαγραφής ("δικαίωμα στη λήθη")</li>
                    <li>Δικαίωμα περιορισμού της επεξεργασίας</li>
                    <li>Δικαίωμα εναντίωσης</li>
                    <li>Δικαίωμα φορητότητας των δεδομένων</li>
                </ul>
                <p>
                    Για την άσκηση οποιουδήποτε από τα παραπάνω δικαιώματα, παρακαλούμε επικοινωνήστε μαζί μας στο: <strong><a href="mailto:support@teachers-app.com">support@teachers-app.com</a></strong>
                </p>

                <h3>8. Ενημερώσεις στην Πολιτική</h3>
                <p>
                    Η παρούσα πολιτική απορρήτου μπορεί να τροποποιείται οποτεδήποτε. Οποιεσδήποτε αλλαγές θα δημοσιεύονται σε αυτήν τη σελίδα με ημερομηνία τελευταίας ενημέρωσης.
                </p>
            </Container>
        </main>
    <Footer />
    </div>
  );
};


export default PrivacyPolicy;
